(ns manatee.annotation.ids)

(def annotation-alert-banner :annotation-alert-banner)
(def dashboard-alert-banner :dashboard-alert-banner)
(def rejection-alert-banner :rejection-alert-banner)
(def report-alert-banner :rejection-alert-banner)
(def approve-multi-modal :approve-multi-modal)
(def reject-item-modal :reject-item-modal)
(def report-item-modal :report-item-modal)
(def notes-modal :notes-modal)
(def submit-item-modal :submit-item-modal)
